import {Injectable} from '@angular/core';
import {FloatTopUpBankDetails, IEnvironment, PAGE_HEADER_KEY_VALUE_PAIR} from '../../../environments/ienvironment';
import {environment} from '../../../environments/environment';

@Injectable({
    providedIn: 'root'
})
export class EnvironmentService implements IEnvironment
{
    get production()
    {
        return environment.production;
    }

    get reconFileDownloadable()
    {
        return environment.reconFileDownloadable;
    }

    get recaptcha()
    {
        return environment.recaptcha;
    }

    get name()
    {
        return environment.name;
    }

    get instanceName()
    {
        return environment.instanceName;
    }

    get assetSubDirectory()
    {
        return environment.assetSubDirectory;
    }

    get logoMain()
    {
        return environment.logoMain;
    }

    get logoMobile()
    {
        return environment.logoMobile;
    }

    get logoSecondary()
    {
        return environment.logoSecondary;
    }

    get gatewayLogoSrc(): string | undefined
    {
        return environment.gatewayLogoSrc;
    }

    get domainUrl()
    {
        return environment.domainUrl;
    }

    get generalTermsLink()
    {
        return environment.generalTermsLink;
    }

    get serviceTermsLink()
    {
        return environment.serviceTermsLink;
    }

    get gatewayMerchantTermsLink()
    {
        return environment.gatewayMerchantTermsLink;
    }

    get privacyNoticeLink()
    {
        return environment.privacyNoticeLink;
    }

    get privacyNoticeLabel()
    {
        return environment.privacyNoticeLabel;
    }

    get serviceTermsLabel()
    {
        return environment.serviceTermsLabel;
    }

    get gatewayMerchantTermsLabel()
    {
        return environment.gatewayMerchantTermsLabel;
    }

    get walkThroughLink()
    {
        return environment.walkThroughLink;
    }

    get swaggerMerchantAPILink()
    {
        return environment.swaggerMerchantAPILink;
    }

    get setupGuideLink(): string
    {
        return environment.setupGuideLink;
    }

    get getHelpModalText()
    {
        return environment.getHelpModalText;
    }

    get supportPortalUrl(): string
    {
        return environment.supportPortalUrl;
    }

    get domainVerificationSla(): string
    {
        return environment.domainVerificationSla;
    }

    get inAppInstanceLogoPaddingClass(): string
    {
        return environment.inAppInstanceLogoPaddingClass;
    }

    get contentHeaderLogoWidth(): number
    {
        return environment.contentHeaderLogoWidth;
    }

    get eCommerceEnabled(): boolean
    {
        return environment.eCommerceEnabled;
    }

    get signupSuccessModalTag(): string | undefined
    {
        return environment.signupSuccessModalTag;
    }

    get floatTopUpBankDetails(): FloatTopUpBankDetails
    {
        return environment.floatTopUpBankDetails;
    }

    getPageHeaders(): PAGE_HEADER_KEY_VALUE_PAIR
    {
        return environment.getPageHeaders();
    }
}
